class TradeshowCustomer {
	constructor(id, avatarIndex, productType, productCount, discount, state) {
		this.id = id;
		this.avatarIndex = avatarIndex;
		this.productType = productType;
		this.productCount = productCount;
		this.discount = discount;
		this.state = state;
	}

	toPlainObj() {
		return {
			id: this.id,
			avatarIndex: this.avatarIndex,
			productType: this.productType,
			productCount: this.productCount,
			discount: this.discount,
			state: this.state
		};
	}
}

function TradeshowCustomerBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withAvatarIndex: function (avatarIndex) {
			this.avatarIndex = avatarIndex;
			return this;
		},
		withProductType: function (productType) {
			this.productType = productType;
			return this;
		},
		withProductCount: function (productCount) {
			this.productCount = productCount;
			return this;
		},
		withDiscount: function (discount) {
			this.discount = discount;
			return this;
		},
		withState: function (state) {
			this.state = state;
			return this;
		},
		build: function () {
			return new TradeshowCustomer(
				this.id,
				this.avatarIndex,
				this.productType,
				this.productCount,
				this.discount,
				this.state
			);
		}
	};
}


/* eslint-disable camelcase */
export default function CreateTradeshowCustomer(tradeshow_customer) {
	return new TradeshowCustomerBuilder()
		.withId(tradeshow_customer.id)
		.withAvatarIndex(tradeshow_customer.avatar_index)
		.withProductType(tradeshow_customer.product_name)
		.withProductCount(parseInt(tradeshow_customer.requested_product_count))
		.withDiscount(parseInt(tradeshow_customer.requested_discount))
		.withState(tradeshow_customer.state)
		.build()
		.toPlainObj();
}
/* eslint-enable camelcase */
